module.exports = __webpack_public_path__ + "media/application/images/logo_dark-7f3d37c25aa04082857d3e0e6fd2cd3d.svg";